import React, {useEffect, useState} from "react"
import ReactModal from 'react-modal'
import styles from "./workforcesubnav.css"


const workforcesubNav = ( { }) => {

    
    
    return (
        <section className="subnav" id="subNav">
            <div className="containfix">
            <a className="subNavButton" href="https://www.fedscoop.com/events/snglive/remote-workforce-may/#About">ABOUT</a>
                <a className="subNavButton" href="https://www.fedscoop.com/events/snglive/remote-workforce-may/#Speakers">SPEAKERS</a>
                {/*<a className="subNavButton" onClick={ ()=> alert('Agenda coming soon!') } href="#Agenda">AGENDA</a>*/}
                <a className="subNavButton" href="https://www.fedscoop.com/events/snglive/remote-workforce-may/wrap-up" target="_blank">WRAP-UP</a>
            </div>
         </section>
    )
}

export default workforcesubNav